import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {UserPermissions} from '../../../../shared/interface/user-permissions';
import {AuthService} from '../../../../shared/services/auth.service';
import {ReplaySubject} from 'rxjs';
import {RiskConfiguration} from '../../../../shared/interface/risk-configuration';
import {RiskRate, TYPE_PARTNERS, TYPE_THRESHOLD} from '../../../../shared/interface/risk-rate';
import {Risk} from '../../../../shared/interface/risk';
import {AllRisksListComponent} from "../all-risks-list/all-risks-list.component";
import {RiskCommissionRate} from "../../../../shared/interface/risk-commission-rate";
import {CommissionTableListItem} from "../../../../shared/interface/commission-table";

@Component({
  selector: 'app-risk-group-view',
  templateUrl: './risk-group-view.component.html',
  styleUrls: ['./risk-group-view.component.scss']
})
export class RiskGroupViewComponent implements OnInit {
  @Input() riskConfiguration: RiskConfiguration;
  @Output() modifyClicked = new EventEmitter<any>();
  @Input() initialFiltersRisk: any;
  @Input() commissionTables: CommissionTableListItem[] = [];

  readonly TYPE_PARTNERS = TYPE_PARTNERS;
  readonly TYPE_THRESHOLD = TYPE_THRESHOLD;

  userPermissions: ReplaySubject<UserPermissions>;

  constructor(
    private auth: AuthService,
  ) {
    this.userPermissions = auth.getUserPermissions();
  }

  ngOnInit(): void {
  }

  modify(): void {
    this.modifyClicked.emit();
  }

  getRiskRates(risk: Risk, type: string): RiskRate[] {
    const result: RiskRate[] = [];

    risk.customRates.forEach((customRate: RiskRate) => {
      if (customRate.type === type) {
        result.push(customRate);
      }
    });

    if (type === this.TYPE_THRESHOLD) {
      return result.sort((a: RiskRate, b: RiskRate) => a.thresholdFrom - b.thresholdFrom);
    }

    return result;
  }

  getCommissionRatePaid(
    risk: Risk,
    commissionTableUuid: string
  ): string | null {

    return this.getCommissionRate(
      risk,
      commissionTableUuid
    )?.ratePaid ?? null;
  }

  getCommissionRate(
    risk: Risk,
    commissionTableUuid: string
  ): RiskCommissionRate | null {

    if (!risk.commissionRates) {
      return null;
    }

    return risk.commissionRates.find(
      (rate: RiskCommissionRate) =>
        rate.commissionTableUuid === commissionTableUuid
    ) ?? null;
  }
}
